import { render, staticRenderFns } from "./CarrierQuotesView.vue?vue&type=template&id=8c2c256c&scoped=true&"
import script from "./CarrierQuotesView.vue?vue&type=script&lang=js&"
export * from "./CarrierQuotesView.vue?vue&type=script&lang=js&"
import style0 from "./CarrierQuotesView.vue?vue&type=style&index=0&id=8c2c256c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2c256c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c2c256c')) {
      api.createRecord('8c2c256c', component.options)
    } else {
      api.reload('8c2c256c', component.options)
    }
    module.hot.accept("./CarrierQuotesView.vue?vue&type=template&id=8c2c256c&scoped=true&", function () {
      api.rerender('8c2c256c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/CarrierQuotesView.vue"
export default component.exports